import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const sponsorBannerListState = (state: AppState) => state.contentManagement.sponsorBanner.sponsorBannerList;

export const sponsorBannerListItemsSelector = createSelector(sponsorBannerListState, state => {
    const sponsorBannerItems = state.items;
    return {
        ...sponsorBannerItems,
        items: sponsorBannerItems.items.map(item => ({
            ...item,
            previewImage: item.image['96x48'],
        })),
    };
});
export const sponsorBannerListRequestingSelector = createSelector(sponsorBannerListState, state => state.requesting);
